import axios from 'axios';
export const API_BASE = process.env.REACT_APP_BACKEND_URL;
if (!API_BASE) throw new Error('REACT_APP_BACKEND_URL is required');
export const api = axios.create({baseURL: `${API_BASE}/api`, withCredentials: true});
api.interceptors.response.use(response=>{
  if(response.data?.csrf_token) api.defaults.headers.common['X-CSRF-Token']=response.data.csrf_token;
  if(response.config.url==='/auth/logout') delete api.defaults.headers.common['X-CSRF-Token'];
  return response;
});
export const mediaUrl = value => value?.startsWith('/api/') ? `${API_BASE}${value}` : value;
export const errorText = error => typeof error?.response?.data?.detail === 'string' ? error.response.data.detail : 'Údaje sa nepodarilo uložiť. Skontrolujte formulár a skúste to znova.';
export async function downloadExport(format, publishedOnly=false) {
  const {data} = await api.get('/admin/export', {params:{format,published_only:publishedOnly},responseType:'blob'});
  const url = URL.createObjectURL(data); const link = document.createElement('a');
  link.href=url; link.download=`lovap-reality.${format}`; link.click(); URL.revokeObjectURL(url);
}